import Loader from "@/components/Loader/Loader";
import { useGetDealQuery } from "@/redux/rtk/features/CRM/deal/dealApi";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DealProfile from "./DealProfile";

export default function DetailsDeal() {
  const { t } = useTranslation();
  const { id } = useParams();
  const {
    data: deal,
    isLoading: dealLoading,
    isError: dealError,
    refetch: refetchDeal,
  } = useGetDealQuery(id, {
    skip: !id,
    refetchOnMountOrArgChange: true,
  });

  if (dealLoading) {
    return <Loader />;
  }

  if (dealError) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-red-500 text-lg">{t("deal.errorLoading")}</p>
          <p className="text-gray-500">{t("deal.tryAgain")}</p>
        </div>
      </div>
    );
  }

  if (!deal) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-gray-500 text-lg">{t("deal.notFound")}</p>
        </div>
      </div>
    );
  }

  return <DealProfile deal={deal} onUpdate={refetchDeal} />;
}
